import * as React from 'react'

const Instagram = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Instagram logo'
    fill='none'
    height='20'
    role='img'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Instagram logo</title>
    <rect width='20' height='20' x='2' y='2' rx='5' ry='5' />
    <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
    <line x1='17.5' x2='17.51' y1='6.5' y2='6.5' />
  </svg>
)

export default Instagram



// WEBPACK FOOTER //
// ./src/components/icons/ui/Instagram.tsx